import { render, staticRenderFns } from "./formalDesign.vue?vue&type=template&id=e9d28fde&scoped=true"
import script from "./formalDesign.vue?vue&type=script&lang=js"
export * from "./formalDesign.vue?vue&type=script&lang=js"
import style0 from "./formalDesign.vue?vue&type=style&index=0&id=e9d28fde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9d28fde",
  null
  
)

export default component.exports